export default __webpack_public_path__ + "static/media/352.f98cb783.png";